import React from 'react'
import { buildFileUrl } from '../../config/strapi'
import { SecondCard as SecondCardType } from '../../types/strapi'

interface SecondCardMobileProps {
  card: SecondCardType
}

export function SecondCardMobile({ card }: SecondCardMobileProps) {
  if (!card) return null

  const headers = card.Header || []
  const image = card.image?.url ? buildFileUrl(card.image.url) : undefined

  return (
    <section
      style={{
        width: '100%',
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'clamp(15px, 3vw, 25px) 0 0 0',
        minHeight: 400,
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }}
    >
      {/* Container dos textos - CORRIGIDO para centralização perfeita */}
      <div
        style={{
          width: '100%',
          maxWidth: '90vw', // Limita a largura para evitar que os textos toquem as bordas
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center', // Centraliza horizontalmente
          justifyContent: 'center',
          margin: '0 auto',
          padding: '0 20px', // Padding lateral para espaçamento
          textAlign: 'center', // Centraliza o texto
        }}
      >
        {/* Renderiza múltiplos headers */}
        {headers.map((header, index: number) => (
          <div key={index} style={{
            marginBottom: index < headers.length - 1 ? '24px' : '0'
          }}>
            <h2 style={{
              fontSize: 28,
              fontWeight: 700,
              marginBottom: 12,
              color: '#111',
              lineHeight: 1.15,
              textAlign: 'center', // Centraliza o texto do título
              maxWidth: '100%', // Usa toda a largura disponível
              letterSpacing: 1,
              width: '100%', // Garante que ocupe toda a largura
            }}>
              {header?.title}
            </h2>
            <p style={{
              fontSize: 18,
              color: '#222',
              lineHeight: 1.5,
              textAlign: 'center', // Centraliza o texto do subtítulo
              maxWidth: '100%', // Usa toda a largura disponível
              letterSpacing: 1,
              width: '100%', // Garante que ocupe toda a largura
            }}>
              {header?.subtitle}
            </p>
          </div>
        ))}
      </div>

      {/* Imagem responsiva abaixo dos textos */}
      {image && (
        <div style={{
          width: '100%',
          maxWidth: '90vw',
          marginTop: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <img
            src={image}
            alt={headers[0]?.title || 'Imagem demonstrativa'}
            style={{
              width: '100%',
              maxWidth: 400,
              height: 'auto',
              objectFit: 'contain',
              transition: 'all 0.3s',
              display: 'block',
            }}
          />
        </div>
      )}
    </section>
  )
} 